import React from 'react';
import PropTypes from 'prop-types';
import Script from 'next/script';

const GoogleTagManager = ({ enabled, containerId, dataLayerName }) => enabled && (
    <Script id={'google-tag-manager'} strategy={'beforeInteractive'}>
        {
            `
                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','${dataLayerName || 'dataLayer'}','${containerId}');
            `
        }
    </Script>
) || null;

GoogleTagManager.propTypes = {
    enabled: PropTypes.bool,
    containerId: PropTypes.string,
    dataLayerName: PropTypes.string,
};

export default GoogleTagManager;
